import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useAuth } from './AuthContext';
import apiClient from '../services/api';
import AuthLayout from './AuthLayout';
import { StyledButton, AlertBox } from '../main/CommonStyles';
import { Loader2, KeyRound, ArrowRight } from 'lucide-react';

const StyledForm = styled.form`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
`;

const StyledInput = styled.input`
    padding: 0.75rem;
    border: 1px solid ${({ theme }) => theme.colors.borderColor};
    border-radius: ${({ theme }) => theme.borderRadius};
    font-size: 1rem;
`;

const InfoBox = styled.div`
    background-color: ${({ theme }) => theme.colors.primaryLightest};
    padding: 1rem;
    border-radius: ${({ theme }) => theme.borderRadius};
    margin-bottom: 1.5rem;
    text-align: left;
`;

const ClaimAccountPage = () => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);
    const { refreshUser } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password.length < 6) {
            return setError('Hasło musi mieć co najmniej 6 znaków.');
        }
        if (password !== confirmPassword) {
            return setError('Hasła nie są zgodne.');
        }
        setError('');
        setSuccess('');
        setLoading(true);
        try {
            await apiClient.post('/user/claim-account', { password });
            await refreshUser();
            setSuccess('Twoje konto jest już w pełni aktywne! Zostaniesz przekierowany na pulpit.');
            setTimeout(() => navigate('/app/dashboard'), 2000);
        } catch (err) {
            setError(err.response?.data?.message || 'Wystąpił błąd.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <AuthLayout title="Zabezpiecz Swoje Konto" subtitle="Ustaw hasło, aby móc w przyszłości łatwo logować się na swoje konto.">
            {error && <AlertBox type="error">{error}</AlertBox>}
            {success && <AlertBox type="success">{success}</AlertBox>}

            <InfoBox>
                <p><strong>Dlaczego warto to zrobić?</strong></p>
                <ul style={{fontSize: '0.9rem', paddingLeft: '1.2rem', marginTop: '0.5rem'}}>
                    <li>Będziesz mógł/mogła logować się hasłem na dowolnym urządzeniu.</li>
                    <li>Opcjonalnie połączysz swoje konto z Google/Facebook.</li>
                    <li>Twój jednorazowy kod dostępu przestanie działać.</li>
                </ul>
            </InfoBox>

            <StyledForm onSubmit={handleSubmit}>
                <StyledInput type="password" placeholder="Nowe hasło (min. 6 znaków)" value={password} onChange={e => setPassword(e.target.value)} required disabled={loading || !!success} />
                <StyledInput type="password" placeholder="Potwierdź hasło" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required disabled={loading || !!success} />
                <StyledButton type="submit" disabled={loading || !!success}>
                    {loading ? <Loader2 className="icon-spin" /> : <KeyRound />}
                    Ustaw Hasło i Zabezpiecz Konto
                </StyledButton>
            </StyledForm>
        </AuthLayout>
    );
};

export default ClaimAccountPage;